var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRectangleBgPurple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 594,
    height: 326,
    viewBox: "0 0 594 326",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5769 43.2744C27.6165 32.9876 28.3885 25.3681 29.7457 19.5408C31.0965 13.7412 33 9.84745 36.2177 6.93851C39.4355 4.02957 43.5008 2.5272 49.4069 1.76639C55.3412 1.00194 62.9997 1 73.3388 1H543.905C556.336 1 565.554 1.00229 572.563 1.97859C579.544 2.95092 584.163 4.86956 587.514 8.57581C590.864 12.2821 592.309 17.071 592.574 24.1139C592.841 31.1855 591.916 40.3575 590.667 52.7257L567.423 282.726C566.383 293.012 565.612 300.632 564.254 306.459C562.904 312.259 561 316.153 557.782 319.061C554.565 321.97 550.499 323.473 544.593 324.234C538.659 324.998 531 325 520.661 325H50.0953C37.6641 325 28.4456 324.998 21.4367 324.021C14.4561 323.049 9.83674 321.13 6.48616 317.424C3.13557 313.718 1.69112 308.929 1.42558 301.886C1.15896 294.815 2.08357 285.642 3.33347 273.274L26.5769 43.2744Z",
    fill: "white",
    fillOpacity: 0.08,
    stroke: "#B43EE9",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectangleBgPurple);
export default __webpack_public_path__ + "static/media/rectangle_bg_purple.d40fbd72e91ab680e9a0b350516d5673.svg";
export { ForwardRef as ReactComponent };